module.exports = {"610327100":"城关镇","610327101":"东风镇","610327102":"八渡镇","610327104":"东南镇","610327106":"温水镇","610327107":"天成镇","610327108":"曹家湾镇","610327109":"固关镇","610327112":"河北镇","610327113":"新集川镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610327.json
// module id = 2801
// module chunks = 0